export default __webpack_public_path__ + "static/media/PencilEdit.1f4951f2.svg";